import React from 'react';

const MaterialsSection = () => {
  const sectionStyle = {
    padding: '5rem 1.5rem',
    backgroundColor: 'rgba(26, 26, 26, 0.8)',
    position: 'relative'
  };

  const containerStyle = {
    maxWidth: '72rem',
    margin: '0 auto'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '4rem'
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '1.5rem'
  };

  const highlightStyle = {
    color: '#dfa926'
  };

  const descriptionStyle = {
    fontSize: '1.125rem',
    color: '#d1d5db',
    maxWidth: '48rem',
    margin: '0 auto',
    lineHeight: '1.6'
  };

  const contentGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '4rem',
    alignItems: 'center'
  };

  const qualityContentStyle = {
    order: 1
  };

  const qualityTitleStyle = {
    fontSize: '2.25rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '2.5rem',
    lineHeight: '1.2',
    textAlign: 'left'
  };

  const featureListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0
  };

  const featureItemStyle = {
    marginBottom: '2rem'
  };

  const featureTitleStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    color: 'white',
    fontWeight: '600',
    marginBottom: '0.75rem',
    fontSize: '1.125rem',
    lineHeight: '1.3'
  };

  const bulletStyle = {
    width: '0.5rem',
    height: '0.5rem',
    backgroundColor: '#dfa926',
    borderRadius: '50%',
    marginRight: '1rem',
    marginTop: '0.5rem',
    flexShrink: 0
  };

  const featureDescStyle = {
    color: '#9ca3af',
    fontSize: '1rem',
    lineHeight: '1.6',
    marginLeft: '1.5rem',
    textAlign: 'left'
  };

  const imageContainerStyle = {
    order: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '0.5rem'
  };

  const placeholderStyle = {
    width: '400px',
    height: '300px',
    background: 'linear-gradient(45deg, #3a3a3a, #1a1a1a)',
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9ca3af',
    fontSize: '1rem',
    textAlign: 'center'
  };

  const qualityFeatures = [
    {
      title: "Multi-Layer Insulation",
      description: "Advanced insulation core for superior thermal performance"
    },
    {
      title: "Premium Wood Frame", 
      description: "FSC certified wood construction for strength and sustainability"
    },
    {
      title: "Weather Protection",
      description: "Multiple sealing layers to protect against all weather conditions"
    },
    {
      title: "Quality Hardware",
      description: "Precision-engineered hinges and locking mechanisms"
    }
  ];

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>
            Premium <span style={highlightStyle}>Materials</span>
          </h2>
          <p style={descriptionStyle}>
            We use only the finest high-quality materials in our door construction, ensuring 
            durability, insulation, and long-lasting performance.
          </p>
        </div>

        <div style={contentGridStyle}>
          <div style={qualityContentStyle}>
            <h3 style={qualityTitleStyle}>Quality Construction</h3>
            
            <ul style={featureListStyle}>
              {qualityFeatures.map((feature, index) => (
                <li key={index} style={featureItemStyle}>
                  <div style={featureTitleStyle}>
                    <span style={bulletStyle}></span>
                    <span>{feature.title}</span>
                  </div>
                  <p style={featureDescStyle}>
                    {feature.description}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <div style={imageContainerStyle}>
            <img 
              src="/SectionCuts0010.png" 
              alt="Door Cross Section"
              style={imageStyle}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `
                  <div style="width: 400px; height: 300px; background: linear-gradient(45deg, #3a3a3a, #1a1a1a); border-radius: 0.5rem; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 1rem; text-align: center;">
                    Door Cross-Section<br/>Construction Details
                  </div>
                `;
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MaterialsSection;
